import {FC, ReactElement, useContext, useEffect} from "react";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {AuthContext} from "@buildwitt/shapeshift-identity";

interface IProps {
	children: ReactElement,
}

export const RequireAuth: FC<IProps> = ({children}) => {
	const location = useLocation();
	const navigate = useNavigate();
	const {authenticated} = useContext(AuthContext);

	useEffect(() => {
		if(!authenticated){
			navigate("/");
		}
	}, [authenticated])

	if (!authenticated)
		return <Navigate to="/" state={{from: location}} />;

	return children;
}